import { SagaIterator } from 'redux-saga';
import { all, put, takeEvery } from 'redux-saga/effects';
import ddt from '@wix/da-ddt';
import { receiveHubMessage } from './actions';
import { addNotificationToQueue } from '../../Notifications/redux/actionCreators';
import { NotificationType } from '../../Notifications/redux/types';
import { HubChannel } from './types';
import { dreamupGenerationSucceeded, dreamupGenerationFailed } from '../dreamup/actions';
import { batchDeviationUpdateComplete } from '../deviations/actionCreators';

export function* handleHubMessage({ payload }) {
  const { channel, data } = payload;

  switch (channel) {
    case HubChannel.NOTIFICATIONS: {
      const notificationData = data.payload;
      yield put(addNotificationToQueue('live', NotificationType.Live, notificationData));
      ddt.log('hub', 'live notification enqueued', notificationData);
      break;
    }
    case HubChannel.DREAMSOFART: {
      const dreamupData = data.payload;
      if (dreamupData.status === 'complete') {
        yield put(dreamupGenerationSucceeded(dreamupData.generation_id, dreamupData.deviationids));
      } else if (dreamupData.status === 'error') {
        yield put(
          dreamupGenerationFailed(
            dreamupData.generation_id,
            dreamupData.free_prompts_remaining,
            dreamupData.error
          )
        );
      } else {
        yield put(
          dreamupGenerationFailed(
            dreamupData.generation_id,
            dreamupData.free_prompts_remaining,
            undefined
          )
        );
      }
      ddt.log('hub', 'dreamup art generation finished', dreamupData);
      break;
    }
    case HubChannel.DREAMSOFART_INPAINT: {
      const inpaintData = data.payload;
      const muro = globalThis.__MURO;
      if (!muro) {
        break;
      }
      if (inpaintData.status === 'complete') {
        ddt.log('hub', 'Inpaint generation succeeded', inpaintData);
        muro.reduxBridge({
          type: 'INPAINT_SUCCESS',
          payload: { generationId: inpaintData.generation_id },
        });
      } else if (inpaintData.status === 'error') {
        ddt.error('hub', 'Inpaint generation failed', inpaintData);
        muro.reduxBridge({
          type: 'INPAINT_ERROR',
          payload: {
            generationId: inpaintData.generation_id,
            errorCode: inpaintData.errorCode,
          },
        });
      } else {
        ddt.error('hub', 'Inpaint generation - coin landed on its side?', inpaintData);
        muro.reduxBridge({
          type: 'INPAINT_ERROR',
          payload: {
            generationId: inpaintData.generation_id,
            errorCode: undefined,
          },
        });
      }
      break;
    }
    case HubChannel.BATCH_COMPLETE: {
      const batchData = data.payload;
      yield put(
        batchDeviationUpdateComplete({
          batchId: batchData.batchid,
          name: batchData.name,
          processedCount: parseInt(batchData.total_processed || '0'),
          failedCount: parseInt(batchData.errors || '0'),
        })
      );
      ddt.log('hub', 'Batch completed', batchData);
      break;
    }
    default:
      break;
  }
}

export default function* saga(): SagaIterator {
  yield all([takeEvery(receiveHubMessage, handleHubMessage)]);
}
